import React, { useEffect, useRef } from 'react';
import { MessageBubble, Message } from './MessageBubble';
import { TypingIndicator } from './TypingIndicator';
import { IconEar, IconCalendarCheck, IconBabyCarriage } from '@tabler/icons-react';
interface MessageListProps {
  messages: Message[];
  isTyping: boolean;
  onPreviewClick?: (checklist: {
    title: string;
    items: any[];
  }) => void;
  onWidgetResponse?: (response: string) => void;
  onWidgetSkip?: () => void;
  onShortcutClick?: (shortcut: string) => void;
}
export function MessageList({
  messages,
  isTyping,
  onPreviewClick,
  onWidgetResponse,
  onWidgetSkip,
  onShortcutClick
}: MessageListProps) {
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  useEffect(() => {
    scrollToBottom();
  }, [messages, isTyping]);
  const isEmpty = messages.length === 0 && !isTyping;
  const shortcuts = [{
    id: 'listen',
    icon: IconEar,
    label: 'Ascoltare e raccogliere informazioni',
    prompt: 'Vorrei raccontarti qualcosa sui miei figli'
  }, {
    id: 'activities',
    icon: IconCalendarCheck,
    label: 'Aiutarti con le attività quotidiane',
    prompt: 'Aiutami a organizzare le attività di oggi'
  }, {
    id: 'questions',
    icon: IconBabyCarriage,
    label: 'Rispondere a domande sui tuoi figli',
    prompt: 'Ho una domanda su mio figlio'
  }];
  const handleShortcutClick = (shortcut: (typeof shortcuts)[0]) => {
    if (onShortcutClick) {
      onShortcutClick(shortcut.prompt);
    }
  };
  return <div className="flex-1 overflow-y-auto px-4 py-6" data-message-list data-id="element-179">
      {/* Welcome message when empty - centered vertically */}
      {isEmpty ? <div className="h-full flex items-center justify-center" data-id="element-180">
          <div className="flex flex-col items-center justify-center text-center px-0 w-full" data-id="element-181">
            <h1 className="font-rubik font-bold text-3xl text-yeppy-text mb-3" data-id="element-182">
              Ciao 👋
            </h1>
            <p className="text-base text-yeppy-text text-opacity-70 max-w-md leading-relaxed mb-8 px-4" data-id="element-183">
              Sono qui per{' '}
              <span className="bg-yeppy-yellow bg-opacity-50 px-2 py-1 rounded-md font-medium text-yeppy-text" data-id="element-184">
                aiutarti
              </span>{' '}
              con le tue attività quotidiane. Inizia quando vuoi!
            </p>

            {/* Shortcuts */}
            <div className="w-full space-y-2" data-id="element-185">
              <p className="text-xs text-yeppy-text text-opacity-50 uppercase tracking-wider mb-2" data-id="element-186">
                Cosa posso fare per te
              </p>
              {shortcuts.map(shortcut => <button key={shortcut.id} onClick={() => handleShortcutClick(shortcut)} className="w-full flex items-center gap-3 p-4 bg-white border border-yeppy-text border-opacity-10 rounded-2xl text-left transition-transform active:scale-[0.98]" data-id="element-187">
                  <div className="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center bg-yeppy-bg" data-id="element-188">
                    <shortcut.icon className="w-5 h-5 text-yeppy-text" stroke={1.5} data-id="element-189" />
                  </div>
                  <span className="text-sm text-yeppy-text text-opacity-80" data-id="element-190">
                    {shortcut.label}
                  </span>
                </button>)}
            </div>
          </div>
        </div> : <div className="max-w-2xl mx-auto space-y-4" data-id="element-191">
          {messages.map((message, index) => <MessageBubble key={message.id} message={message} onPreviewClick={onPreviewClick} onWidgetResponse={index === messages.length - 1 ? onWidgetResponse : undefined} onWidgetSkip={index === messages.length - 1 ? onWidgetSkip : undefined} onShortcutClick={onShortcutClick} data-id="element-192" />)}
          {isTyping && <TypingIndicator data-id="element-193" />}
          <div ref={messagesEndRef} data-id="element-194" />
        </div>}
    </div>;
}